import { IRangeValidation, IOption } from '@common/interfaces/input.interface';


export const CONTACT_BOX_ICONS = [
  'i-celphone',
  'i-phone'
];

export const LOCATION_BOX_ICONS = [];

export const CALL_CENTER_NUMBER = '2 27821020';

export const CALL_CENTER_SECOND_NUMBER = '800 200 007';

export const CALL_CENTER_NUMBER_HOME = '600 2888 888';

export const DEFAULT_EMPTY_OBJECT_ENCODED = 'e30=';

export const FAKE_LOAD_MS = 500;


export const RUT_VALIDATION: IRangeValidation = {
  max: 14
};

export const NAME_VALIDATION: IRangeValidation = {
  min: 2,
  max: 20
};

export const PAYMENT_CARD_AMOUNT_VALIDATION: IRangeValidation = {
  min: 1
};

export const CARD_NUMBER_VALIDATION: IRangeValidation = {
  min: 19,
  max: 19
};

export const PHONE_VALIDATION: IRangeValidation = {
  min: 11,
  max: 11,
};

export const EMAIL_VALIDATION: IRangeValidation = {
  min: 8,
  max: 40
};

export const INSTALLMENTS_VALIDATION: IRangeValidation = {
  min: 3,
  max: 24
};

export const SIMULATION_AMOUNT_VALIDATION: IRangeValidation = {
  min: 5000,
  max: 1000000
};

export const COMMENT_VALIDATION: IRangeValidation = {
  max: 200
};

export const EMAIL_PATTERN = new RegExp(/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,63}$/);

// eslint-disable-next-line no-useless-escape
export const NAME_REGEX = new RegExp(/^[a-zA-ZàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸ]+$/);

export const MAX_AMOUNT_VALIDATION: IRangeValidation = {
  min: 1
};

export const DEFERRED_MONTHS: IOption[] = [ { value: '0', label: 'Sin meses diferidos' }, { value: '1' } ];

export const PAY_DAY: IOption[] = [ { value: '5' }, { value: '15' }, { value: '25' } ];

export const INVOICED_AMOUNT_KEY = 'invoicedAmount';

export const MINIMAL_AMOUNT_KEY = 'minimalAmount';

export const OLD_SITE = 'https://www.tarjetaspin.cl/';

export const LOGIN_PRIVATE_SITE = 'https://sucursalvirtual.tarjetaspin.cl';


